// RLoaderScreen — full-screen branded loading splash built around <RLoader>.
// Ported from the Resolute Design System handoff (R Loader.html stage). Fixed
// overlay so it can cover the login page during the auth-mode check and, more
// importantly, stay up while the backend is briefly unreachable mid-deploy —
// keeping the animation looping until the service answers again.
import RLoader from "./RLoader";

const NAVY = "#07054B";
const LIGHT = "#FAFAFC";

export default function RLoaderScreen({
  label = "Loading",
  variant = "trace",
  bg = "navy",
  speed = 0.3,
  size = 100,
  accent = "#338BF7",
}) {
  const bgDark = bg === "navy";
  const stageBg = bgDark ? NAVY : LIGHT;
  const labelColor = bgDark ? "rgba(255,255,255,0.6)" : "#61657D";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "grid",
        placeItems: "center",
        padding: 48,
        boxSizing: "border-box",
        background: stageBg,
      }}
    >
      <style>{`
        @keyframes rsl-dots {
          0%   { content: ""; }
          25%  { content: "."; }
          50%  { content: ".."; }
          75%  { content: "..."; }
          100% { content: ""; }
        }
        .rsl-dots::after {
          content: "";
          animation: rsl-dots 1.4s steps(4, end) infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .rsl-dots::after { animation-duration: 0.001ms !important; }
        }
      `}</style>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 28 }}>
        <RLoader variant={variant} accent={accent} speed={speed} bgDark={bgDark} size={size} />
        {label && (
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              color: labelColor,
            }}
          >
            {label}
            <span className="rsl-dots" />
          </div>
        )}
      </div>
    </div>
  );
}
